module.exports = __webpack_public_path__ + "img/26.624efe8b.png";